import { checkCampaignValidity, getCampaign } from "../apiLoader/campaign";
import { updateCampaign } from "../stores/campaign";
import { getUnixTimeMinuteGranularity } from "../utils";

export const loadCampaign = async (campaignKey: string) => {
  const timestamp = getUnixTimeMinuteGranularity();
  const response = await getCampaign(campaignKey, timestamp);
  updateCampaign(response.result);
};

export const validateAndUpdateCampaign = async (campaignKey: string) => {
  const timestamp = getUnixTimeMinuteGranularity();
  const update = {
    is_valid: true
  };

  try {
    await checkCampaignValidity(campaignKey, timestamp);
  } catch (error) {
    update.is_valid = false;
  }

  updateCampaign(update);
};
